module.exports = __webpack_public_path__ + "static/media/Perform_Air_Logo_white.d2397417.svg";